import { useNavigate } from 'react-router-dom'
import { customerData } from '../../../utilities/CustomerData'

export function DashboardChartConnect({ setShowNavBar }) {
  const navigate = useNavigate()

  return (
    <div className='shadow-md p-6 rounded-xl lg:w-full w-11/12 h-fit flex flex-col bg-[#5186C0] font-robo text-white'>
      <div className='w-full flex flex-col items-center'>
        <p className='font-bold text-3xl text-center'>Complete Verification & Calculate Exact Refund</p>
        <div className='w-full flex flex-col items-center gap-4 mt-4'>
          <button 
            onClick={() => { setShowNavBar(false); navigate(`/chartConnect/${customerData.customerLeadData.leadContact.contactId}`) }} 
            className='w-full p-4 bg-[#FF8C00] hover:bg-[#E67E00] transition duration-200 rounded-lg text-3xl font-bold shadow-md'>
              <div className='flex flex-col items-center gap-2'>
                <p>Get My Refund <span className='underline'>NOW!</span></p>
                <p className='text-lg'>Click Here</p>
              </div>
          </button>
          <div className='bg-white p-4 rounded-md shadow-md w-full'>
            <iframe className='w-full aspect-video' src="https://fast.wistia.net/embed/iframe/zbo3195cm1?web_component=true&seo=true" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  )
}